var exports = {
  "rf": "VoiceMessageComposerModal.module__body___SGtNcF",
  "BK": "VoiceMessageComposerModal.module__helpText___SGtNcF",
  "kc": "VoiceMessageComposerModal.module__errorText___SGtNcF",
  "mI": "VoiceMessageComposerModal.module__meta___SGtNcF",
  "sG": "VoiceMessageComposerModal.module__recordingStatus___SGtNcF",
  "ne": "VoiceMessageComposerModal.module__controls___SGtNcF",
  "hZ": "VoiceMessageComposerModal.module__buttonInner___SGtNcF",
};

module.exports = exports;
